import { useAppSelector } from '@/store';

import { isExpertPaymentsConsoleEnabled } from './gate';

/**
 * Single gate the `/admin/expert-payments` route and its admin nav link check.
 *
 * Deploy-controlled, not GrowthBook: `VITE_ENABLE_EXPERT_PAYMENTS_CONSOLE` has
 * to move per environment in lockstep with the api's env-only
 * `ENABLE_EXPERT_PAYMENTS`, and splitting one feature gate across two control
 * planes is how a feature ends up half-on (the ENG-5607 lesson). SSM →
 * `devops/terraform/frontend.tf` → Amplify → `VITE_*` → `config.ts`.
 *
 * The resolution rules live in `gate.ts` as a pure predicate — see there.
 */
export function useExpertPaymentsConsoleEnabled(): boolean {
  const viewer = useAppSelector((state) => state.viewer);
  return isExpertPaymentsConsoleEnabled(viewer);
}
